(function(){
  function init(root){
    if(!root || root.dataset.solenaProductReady==='1') return;
    root.dataset.solenaProductReady='1';

    var mainImg=root.querySelector('[data-main-image]');
    var mediaBox=root.querySelector('.spg-main-media');
    var allThumbs=Array.prototype.slice.call(root.querySelectorAll('[data-thumbs] button'));
    var thumbs=allThumbs.filter(function(btn){return !btn.hidden});
    var currentIndex=Math.max(0,thumbs.findIndex(function(btn){return btn.classList.contains('is-active')}));

    var track=root.querySelector('[data-swipe-track]');
    var allTrackCells=track?Array.prototype.slice.call(track.querySelectorAll('.spg-swipe-cell')):[];
    var trackCells=allTrackCells.filter(function(cell){return !cell.hidden});
    var dotsWrap=root.querySelector('[data-swipe-dots]');
    var dotEls=[];
    var trackIndex=0;
    var trackScrollTimer=null;
    var preloadedImages=Object.create(null);
    var galleryPreloadScheduled=false;

    function preloadImage(src,priority,onReady){
      if(!src)return null;
      var image=preloadedImages[src];
      if(!image){
        image=new Image();
        image.decoding='async';
        if('fetchPriority' in image)image.fetchPriority=priority||'auto';
        preloadedImages[src]=image;
        image.onerror=function(){delete preloadedImages[src]};
        image.src=src;
      }else if(priority==='high'&&'fetchPriority' in image){
        image.fetchPriority='high';
      }
      if(onReady){
        if(image.complete&&image.naturalWidth){
          onReady(image);
        }else{
          image.addEventListener('load',function(){onReady(image)},{once:true});
        }
      }
      return image;
    }

    function mobileImageSrc(src){
      if(!src)return '';
      if(/([?&])width=\d+/.test(src))return src.replace(/([?&])width=\d+/,'$1width=480');
      return src+(src.indexOf('?')>-1?'&':'?')+'width=480';
    }

    function previewImageSrc(src){
      if(!src)return '';
      var width=window.matchMedia&&window.matchMedia('(max-width: 749px)').matches?480:720;
      if(/([?&])width=\d+/.test(src))return src.replace(/([?&])width=\d+/,'$1width='+width);
      return src+(src.indexOf('?')>-1?'&':'?')+'width='+width;
    }

    function preloadVariantImage(input,priority){
      if(!input)return;
      var filterKey=(input.dataset.galleryKey||input.value.toLowerCase().replace(/[^a-z0-9]+/g,'-'));
      var firstThumb=allThumbs.find(function(btn){return mediaMatchesFilter(btn,filterKey)});
      if(!firstThumb)return;
      preloadImage(previewImageSrc(firstThumb.dataset.full),priority||'low');
      if(priority==='high')preloadButtonImage(firstThumb,'high');
    }

    function preloadButtonImage(btn,priority,onReady){
      if(!btn)return null;
      var full=btn.dataset.full;
      var mobile=window.matchMedia&&window.matchMedia('(max-width: 749px)').matches;
      return preloadImage(mobile?mobileImageSrc(full):full,priority,onReady);
    }

    function preloadNextImage(priority){
      if(thumbs.length<=1)return;
      var next=thumbs[(currentIndex+1)%thumbs.length];
      if(next)preloadButtonImage(next,priority||'auto');
    }

    function preloadRemainingImages(){
      thumbs.forEach(function(btn,index){
        if(index===currentIndex)return;
        window.setTimeout(function(){preloadButtonImage(btn,'low')},index*120);
      });
    }

    function scheduleRemainingImagesPreload(){
      if(galleryPreloadScheduled)return;
      galleryPreloadScheduled=true;
      var run=function(){preloadRemainingImages()};
      if('requestIdleCallback' in window){
        window.requestIdleCallback(run,{timeout:900});
      }else{
        window.setTimeout(run,450);
      }
    }

    function scheduleNextImagePreload(){
      var afterMain=function(){
        preloadNextImage('high');
        scheduleRemainingImagesPreload();
      };
      window.setTimeout(function(){preloadNextImage('auto')},120);
      if(mainImg&&!mainImg.complete){
        mainImg.addEventListener('load',afterMain,{once:true});
      }else{
        window.setTimeout(afterMain,0);
      }
    }

    function normalizeSrc(src){
      return (src||'').split('?')[0];
    }

    function absoluteSrc(src){
      if(!src)return '';
      try{return new URL(src,document.baseURI).href}catch(e){return src}
    }

    function mediaMatchesFilter(item,filterKey){
      if(!filterKey)return true;
      var itemKey=(item.dataset.filterKey||'').toLowerCase();
      return itemKey.indexOf(filterKey)>-1;
    }

    function trackVisible(){
      return Boolean(track)&&trackCells.length>1&&track.offsetWidth>0&&getComputedStyle(track).display!=='none';
    }

    function setArrowVisibility(){
      var prev=root.querySelector('.spg-arrow.left');
      var next=root.querySelector('.spg-arrow.right');
      var hide=thumbs.length<=1;
      if(prev)prev.hidden=hide;
      if(next)next.hidden=hide;
    }

    function rebuildDots(){
      dotEls=[];
      if(!dotsWrap)return;
      dotsWrap.textContent='';
      if(trackCells.length<=1){
        dotsWrap.hidden=true;
        return;
      }
      trackCells.forEach(function(cell,index){
        var dot=document.createElement('span');
        if(index===trackIndex)dot.classList.add('on');
        dotsWrap.appendChild(dot);
        dotEls.push(dot);
      });
      dotsWrap.hidden=false;
    }

    function setDots(index){
      dotEls.forEach(function(dot,n){dot.classList.toggle('on',n===index)});
    }

    function scrollTrackTo(index,instant){
      if(!track||!trackCells[index])return;
      trackIndex=index;
      setDots(index);
      if(!trackVisible())return;
      try{track.scrollTo({left:trackCells[index].offsetLeft,behavior:instant?'auto':'smooth'})}
      catch(e){track.scrollLeft=trackCells[index].offsetLeft}
    }

    function setMainImage(src){
      if(!mainImg||!src)return;
      mainImg.removeAttribute('srcset');
      mainImg.src=src;
    }

    function showImage(index){
      if(!thumbs.length)return;
      if(index<0)index=thumbs.length-1;
      if(index>=thumbs.length)index=0;
      currentIndex=index;
      thumbs.forEach(function(item){item.classList.remove('is-active')});
      var btn=thumbs[currentIndex];
      if(!btn)return;
      btn.classList.add('is-active');
      var fullSrc=btn.dataset.full;
      var displayedSrc=mainImg?(mainImg.currentSrc||mainImg.src):'';
      var previewImg=btn.querySelector('img');
      var previewSrc=previewImg&&(previewImg.currentSrc||previewImg.src);
      var fastSrc=previewImageSrc(fullSrc);
      var selectedIndex=currentIndex;
      var selectedFullSrc=fullSrc;
      var cached=preloadedImages[fullSrc];
      var cachedPreview=preloadedImages[fastSrc];

      if(absoluteSrc(displayedSrc)!==absoluteSrc(fullSrc)){
        if(cached&&cached.complete&&cached.naturalWidth){
          setMainImage(fullSrc);
        }else{
          if(cachedPreview&&cachedPreview.complete&&cachedPreview.naturalWidth){
            setMainImage(fastSrc);
          }else if(previewImg&&previewImg.complete&&previewImg.naturalWidth&&previewSrc){
            setMainImage(previewSrc);
          }else{
            setMainImage(fastSrc);
          }
          preloadImage(fullSrc,'high',function(){
            var activeThumb=thumbs[currentIndex];
            if(currentIndex===selectedIndex&&activeThumb&&activeThumb.dataset.full===selectedFullSrc)setMainImage(selectedFullSrc);
          });
        }
      }
      scrollTrackTo(currentIndex);
      scheduleNextImagePreload();
    }

    function showImageBySrc(src){
      if(!src)return false;
      var cleanSrc=normalizeSrc(src);
      var found=thumbs.findIndex(function(btn){return normalizeSrc(btn.dataset.full)===cleanSrc});
      if(found>-1){
        showImage(found);
        return true;
      }
      return false;
    }

    function setMediaFilter(filterKey,preferredSrc){
      filterKey=(filterKey||'').toLowerCase();
      var filteredThumbs=filterKey?allThumbs.filter(function(btn){return mediaMatchesFilter(btn,filterKey)}):[];
      var filteredTrackCells=filterKey?allTrackCells.filter(function(cell){return mediaMatchesFilter(cell,filterKey)}):[];

      thumbs=filteredThumbs.length?filteredThumbs:allThumbs.slice();
      trackCells=filteredTrackCells.length?filteredTrackCells:allTrackCells.slice();
      galleryPreloadScheduled=false;
      currentIndex=0;
      trackIndex=0;

      allThumbs.forEach(function(btn){
        btn.hidden=thumbs.indexOf(btn)===-1;
        btn.classList.remove('is-active');
      });
      allTrackCells.forEach(function(cell){
        cell.hidden=trackCells.indexOf(cell)===-1;
      });

      rebuildDots();
      setArrowVisibility();

      if(preferredSrc&&showImageBySrc(preferredSrc))return;
      if(thumbs.length){
        showImage(0);
      }else if(preferredSrc){
        setMainImage(preferredSrc);
      }
    }

    allThumbs.forEach(function(btn){
      function preloadThumb(){preloadButtonImage(btn,'high')}
      btn.addEventListener('pointerenter',preloadThumb,{passive:true});
      btn.addEventListener('focus',preloadThumb);
      btn.addEventListener('touchstart',preloadThumb,{passive:true});
      btn.addEventListener('click',function(){
        var index=thumbs.indexOf(btn);
        if(index>-1)showImage(index);
      });
    });

    var prev=root.querySelector('.spg-arrow.left');
    var next=root.querySelector('.spg-arrow.right');
    if(prev){prev.addEventListener('click',function(){showImage(currentIndex-1)})}
    if(next){next.addEventListener('click',function(){showImage(currentIndex+1)})}
    setArrowVisibility();

    if(track&&allTrackCells.length){
      allTrackCells.forEach(function(cell){
        var img=cell.querySelector('img');
        if(img)img.draggable=false;
      });
      rebuildDots();
      track.addEventListener('scroll',function(){
        if(trackScrollTimer)clearTimeout(trackScrollTimer);
        trackScrollTimer=setTimeout(function(){
          var width=track.clientWidth;
          if(!width)return;
          var index=Math.round(track.scrollLeft/width);
          index=Math.max(0,Math.min(trackCells.length-1,index));
          if(index===trackIndex)return;
          trackIndex=index;
          setDots(index);
          if(thumbs[index]){
            currentIndex=index;
            thumbs.forEach(function(item){item.classList.remove('is-active')});
            thumbs[index].classList.add('is-active');
          }
          scheduleNextImagePreload();
        },90);
      },{passive:true});
      window.addEventListener('resize',function(){
        if(trackVisible()){
          if(trackCells[trackIndex])track.scrollLeft=trackCells[trackIndex].offsetLeft;
        }else if(thumbs[trackIndex]&&mainImg&&mainImg.getAttribute('src')!==thumbs[trackIndex].dataset.full){
          setMainImage(thumbs[trackIndex].dataset.full);
        }
      });
    }

    if(mediaBox&&allThumbs.length>1){
      mediaBox.style.touchAction='pan-y pinch-zoom';
      mediaBox.style.webkitUserSelect='none';
      if(mainImg){mainImg.draggable=false}

      var sx=0,sy=0,st=0,tracking=false,swiping=false,lastSwipe=0;
      function isInteractive(target){return target&&target.closest&&target.closest('button,a,input,select,textarea,label')}
      function start(x,y,target){
        if(trackVisible())return;
        if(isInteractive(target))return;
        sx=x;sy=y;st=Date.now();tracking=true;swiping=false;
      }
      function move(x,y,event){
        if(!tracking)return;
        var dx=x-sx;
        var dy=y-sy;
        var ax=Math.abs(dx);
        var ay=Math.abs(dy);
        if(!swiping&&ax>10&&ax>ay*1.2){swiping=true}
        if(swiping){
          if(event&&event.cancelable)event.preventDefault();
          if(event)event.stopPropagation();
        }
      }
      function end(x,y,event){
        if(!tracking)return;
        tracking=false;
        var dx=x-sx;
        var dy=y-sy;
        var ax=Math.abs(dx);
        var ay=Math.abs(dy);
        var dt=Date.now()-st;
        if(ax>35&&ax>ay*1.25&&dt<1000){
          lastSwipe=Date.now();
          showImage(currentIndex+(dx<0?1:-1));
          if(event&&event.cancelable)event.preventDefault();
          if(event)event.stopPropagation();
        }
      }
      mediaBox.addEventListener('touchstart',function(event){
        if(!event.touches||event.touches.length!==1)return;
        var t=event.touches[0];
        start(t.clientX,t.clientY,event.target);
      },{passive:true});
      mediaBox.addEventListener('touchmove',function(event){
        if(!event.touches||event.touches.length!==1)return;
        var t=event.touches[0];
        move(t.clientX,t.clientY,event);
      },{passive:false});
      mediaBox.addEventListener('touchend',function(event){
        var t=event.changedTouches&&event.changedTouches[0];
        if(!t)return;
        end(t.clientX,t.clientY,event);
      },{passive:false});
      mediaBox.addEventListener('pointerdown',function(event){
        if(event.pointerType&&event.pointerType!=='touch'&&event.pointerType!=='pen')return;
        if(Date.now()-lastSwipe<400)return;
        start(event.clientX,event.clientY,event.target);
      },{passive:true});
      mediaBox.addEventListener('pointermove',function(event){
        if(event.pointerType&&event.pointerType!=='touch'&&event.pointerType!=='pen')return;
        move(event.clientX,event.clientY,event);
      },{passive:false});
      mediaBox.addEventListener('pointerup',function(event){
        if(event.pointerType&&event.pointerType!=='touch'&&event.pointerType!=='pen')return;
        if(Date.now()-lastSwipe<400)return;
        end(event.clientX,event.clientY,event);
      },{passive:false});
      mediaBox.addEventListener('click',function(event){
        if(Date.now()-lastSwipe<450){
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },true);
    }

    var qty=root.querySelector('.spg-qty-input');
    root.querySelectorAll('[data-qty-action]').forEach(function(btn){btn.addEventListener('click',function(){if(!qty)return;var current=parseInt(qty.value||'1',10);qty.value=btn.dataset.qtyAction==='minus'?Math.max(1,current-1):current+1})});
    var select=root.querySelector('[data-variant-select]');
    var price=root.querySelector('[data-price]');
    var compare=root.querySelector('[data-compare]');
    var discount=root.querySelector('[data-discount]');
    var stock=root.querySelector('[data-stock]');
    var stockWord=root.querySelector('[data-stock-word]');
    var stockExtra=root.querySelector('[data-stock-extra]');
    var atc=root.querySelector('[data-atc]');
    var atcText=atc?atc.querySelector('span'):null;
    function renderSelectedVariant(){
      var optionGroups=Array.prototype.slice.call(root.querySelectorAll('.spg-option'));
      var selectedInputs=optionGroups.map(function(group){return group.querySelector('input:checked')});
      if(!select||selectedInputs.some(function(input){return !input}))return;

      var selectedValues=selectedInputs.map(function(input){return input.value});
      var variantOption=Array.prototype.slice.call(select.options).find(function(option){
        return selectedValues.every(function(value,index){
          return option.dataset['option'+(index+1)]===value;
        });
      });
      if(!variantOption)return;

      select.value=variantOption.value;
      if(price&&variantOption.dataset.price)price.textContent=variantOption.dataset.price;
      if(compare)compare.textContent=variantOption.dataset.compare||'';
      if(discount){
        if(variantOption.dataset.discount){
          discount.textContent=variantOption.dataset.discount;
          discount.hidden=false;
        }else{
          discount.textContent='';
          discount.hidden=true;
        }
      }

      var available=variantOption.dataset.available==='true';
      if(stock)stock.classList.toggle('is-out',!available);
      if(stockWord)stockWord.textContent=available?'În stoc':'Stoc epuizat';
      if(stockExtra)stockExtra.textContent=available?' - Livrare 1-3 zile lucrătoare':'';
      if(atc)atc.disabled=!available;
      if(atcText)atcText.textContent=available?'Adaugă în coș':'Stoc epuizat';

      var galleryInput=selectedInputs[0];
      var firstGroup=optionGroups[0];
      if(firstGroup&&firstGroup.dataset.optionName==='gramaj'&&selectedInputs[1])galleryInput=selectedInputs[1];
      setMediaFilter(galleryInput?(galleryInput.dataset.galleryKey||galleryInput.value.toLowerCase().replace(/[^a-z0-9]+/g,'-')):'',variantOption.dataset.image||'');

      var setInput=selectedInputs.find(function(input){
        var group=input.closest('.spg-option');
        return group&&(group.dataset.optionName==='tip-set'||group.dataset.optionName==='set');
      });
      var setMode=setInput&&setInput.value.toLowerCase().indexOf('matrimonial')>-1?'matrimonial':'single';
      root.querySelectorAll('[data-damask-set-content]').forEach(function(content){
        content.hidden=content.dataset.damaskSetContent!==setMode;
      });
    }
    var variantInputs=Array.prototype.slice.call(root.querySelectorAll('.spg-pills input'));
    variantInputs.forEach(function(input){
      var hitArea=input.closest('label')||input;
      function warmVariantImage(){preloadVariantImage(input,'high')}
      hitArea.addEventListener('pointerenter',warmVariantImage,{passive:true});
      hitArea.addEventListener('touchstart',warmVariantImage,{passive:true});
      input.addEventListener('focus',warmVariantImage);
      input.addEventListener('change',renderSelectedVariant);
    });
    if(variantInputs.length>1){
      var warmRemainingVariants=function(){
        variantInputs.forEach(function(input,index){
          window.setTimeout(function(){preloadVariantImage(input,'low')},index*70);
        });
      };
      if('requestIdleCallback' in window){
        window.requestIdleCallback(warmRemainingVariants,{timeout:700});
      }else{
        window.setTimeout(warmRemainingVariants,250);
      }
    }
    if(variantInputs.length){
      renderSelectedVariant();
    }else{
      setMediaFilter('',mainImg?mainImg.src:'');
    }
    scheduleNextImagePreload();
  }
  function boot(){document.querySelectorAll('[data-solena-product]').forEach(init)}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot)}else{boot()}
  window.addEventListener('load',boot);
})();
